import React from "react"
import PropTypes from "prop-types"
import { Modal, ModalBody, ModalHeader, Table } from "reactstrap"

const GenreModal = props => {
  const { isOpen, toggle, genre } = props
  {
    if (genre !== null)
      return (
        <>
          <Modal
            isOpen={isOpen}
            role="dialog"
            autoFocus={true}
            centered={true}
            className="exampleModal"
            tabIndex="-1"
            toggle={toggle}
          >
            <ModalHeader toggle={toggle}>Genre Details</ModalHeader>
            <ModalBody>
              <Table>
                <tbody>
                  <tr>
                    <th>Genre Name</th>
                    <td>{genre.bg_genreName}</td>
                  </tr>
                  <tr>
                    <th>Status</th>
                    <td>{genre.bg_status ? "Active" : "Inactive"}</td>
                  </tr>
                </tbody>
              </Table>
            </ModalBody>
          </Modal>
        </>
      )
  }
}

GenreModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
}

export default GenreModal
